import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { delay, filter } from 'rxjs/operators';
import { FeedbackDialogComponent } from '../_shared/components/feedback-dialog/feedback-dialog.component';
import { AppService } from '../_shared/services/app.service';
import { PermissionService } from '../_shared/services/permission.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
    public lang: string;

    public username = '...';
    public userId = '...';
    public authenticated$: Observable<boolean>;
    constructor(public appService: AppService, public permissionService: PermissionService, public dialog: MatDialog) {
        this.authenticated$ = this.permissionService.isUserLoggedIn$.pipe(
            filter((v) => v !== undefined),
            delay(10)
        );
    }

    public ngOnInit() {
        this.lang = this.appService.getLanguageOnly();
        this.permissionService.userInfo$.subscribe((user) => {
            if (user?.displayName && user.userId) {
                this.username = user.displayName;
                this.userId = user.userId;
            }
        });
    }

    public onLanguageChanged(lang: string): void {
        this.appService.setLanguage(lang);
    }

    public onSalesOrgChanged(salesorg: string): void {
        this.appService.setSalesOrg(salesorg);
    }

    public openFeedbackDialog(): void {
        this.dialog.open(FeedbackDialogComponent);
    }
}
